import { AsyncPipe, NgFor } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { Fitter } from '@sc/data-access-models';
import { FittersSandboxService } from '@sc/data-access-state-management';
import { TranslatorService } from '@sc/data-access-translation';
import { PhoneNumberPipe } from '@sc/feature-contextual-display';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { AppointmentUtils } from '@sc/utils';
import { RatingComponent } from '../rating';

@Component({
  selector: 'sc-fitter-list-phone-numbers',
  styleUrls: ['./fitter-list-phone-numbers.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgFor,
    RatingComponent,
    PhoneNumberPipe,
    MatCardModule,
    TranslateModule,
    AsyncPipe,
  ],
  template: `
    <div class="data">
      <div class="check">
        <div class="row sc-design-text-3">
          <p>
            {{ getBookWithPhoneInfos(1) }}
          </p>
        </div>
        <div class="row sc-design-text-3">
          <p>
            {{ getBookWithPhoneInfos(2) }}
          </p>
        </div>
      </div>
    </div>
    <mat-card
      appearance="outlined"
      *ngFor="let fitter of sortByDistance(_fitters)"
    >
      <div class="card-header sc-design-text-2">
        <span class="fitter-title">{{ fitter.brand }}</span>
        <sc-rating
          [rating]="fitter?.google?.rating"
          [brandId]="fitter?.brandId"
        ></sc-rating>
      </div>
      <span
        class="address sc-design-text-3"
        [innerHTML]="fittersSB.getCompleteAddress(fitter)"
      ></span>
      <span class="phone sc-design-text-3">
        {{ 'AppointmentsSlot.phoneLabel' | translate }}
        <span class="number" (click)="onPhoneNumberClick(fitter.phone)">
          <a [href]="'tel:' + fitter.phone">
            {{ fitter.phone | phoneNumber | async }}
          </a>
        </span>
      </span>
    </mat-card>
  `,
})
export class FitterListPhoneNumbersComponent {
  @Input() set fitters(fitters: Fitter[]) {
    this._fitters = [];

    this._fitters = fitters;

    if (this._fitters?.length) {
      this._fitters = this._fitters.filter((elem) => {
        return (
          elem.fitterType !== 'MOBILE' ||
          this.featureFlippingService.isBrandFeatureActivated(
            elem.brandId,
            'display-mobile-fitter-on-special-glass'
          )
        );
      });

      this.generateFittersMaps();
    }
  }

  @Output() phoneNumberClickEvent = new EventEmitter<string>();

  fittersById: Map<string, Fitter>;
  _fitters: Fitter[];

  constructor(
    public featureFlippingService: FeatureFlippingManagerService,
    public fittersSB: FittersSandboxService,
    private readonly translator: TranslatorService
  ) {}

  generateFittersMaps(): void {
    this.fittersById = AppointmentUtils._groupFitterById(this.fitters);
  }

  sortByDistance(fitters: Fitter[]): Fitter[] {
    if (!fitters) {
      return [];
    }

    return [...fitters].sort((fitterA, fitterB) => {
      if (fitterA.distance > fitterB.distance) {
        return 1;
      }

      if (fitterA.distance < fitterB.distance) {
        return -1;
      }
      return 0;
    });
  }

  onPhoneNumberClick(phoneNumber: string): void {
    this.phoneNumberClickEvent.emit(phoneNumber);
  }

  getBookWithPhoneInfos(infosIndex: number) {
    const appName = this.fittersSB.getCurrentApp();
    return this.translator.getInstantTranslation(
      `AppointmentsSlot.bookWithPhoneNumberInfos.${appName}.bookWithPhoneNumberInfo${infosIndex}`
    );
  }
}
